var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { caseFilterhash } from '@debbie/common/dist/insights';
import * as authActions from './auth/actions';
import * as blameLogActions from './blamelogs/actions';
import * as caseActions from './case/actions';
import * as caseVouchersActions from './case-vouchers/actions';
import * as casesActions from './cases/actions';
import * as creditorsActions from './creditors/actions';
import * as customersActions from './customers/actions';
import * as economyActions from './economy/actions';
import * as exclusiveContentActions from './exclusiveContent/actions';
import * as homeActions from './home/actions';
import * as hooksActions from './hooks/actions';
import * as importsActions from './imports/actions';
import * as insightsActions from './insights/actions';
import * as integrationActions from './integrations/actions';
import * as interactionsActions from './interactions/actions';
import * as keysActions from './keys/actions';
import * as langActions from './lang/actions';
import { isNotLoaded } from './Loadable/helpers';
import * as localActions from './local/actions';
import * as meActions from './me/actions';
import * as newInteractions from './newInteractions/actions';
import * as proceduresActions from './procedures/actions';
import * as redirectActions from './redirect/actions';
import * as selectedOwnersActions from './selectedOwners/actions';
import store from './store';
import * as templates from './templates/actions';
import * as tenantActions from './tenant/actions';
import * as tenantBillingActions from './tenant-billing/actions';
import * as transactionAccountActions from './transaction-accounts/actions';
import * as updateTypeGroupsActions from './update-type-groups/actions';
import * as updatesTypesActions from './update-types/actions';
import * as usersActions from './users/actions';
import * as voucherApplicationActions from './voucher-applications/actions';
import * as workflowsActions from './workflows/actions';
const loadCaseWorkerAppData = () => __awaiter(void 0, void 0, void 0, function* () {
    let state = store.getState();
    if (isNotLoaded(state.me)) {
        yield meActions.get().then(() => (state = store.getState()));
    }
    if (isNotLoaded(state.allUsers)) {
        usersActions.getAll();
    }
    if (isNotLoaded(state.pausedCases[caseFilterhash(state.caseFilter)])) {
        homeActions.getPausedCases(state.caseFilter);
    }
    if (isNotLoaded(state.procedures)) {
        proceduresActions.get();
    }
    if (isNotLoaded(state.updateTypes)) {
        updatesTypesActions.types();
    }
    if (isNotLoaded(state.templates)) {
        templates.getAll();
    }
    const tenantId = state.selectedOwners[0];
    if (isNotLoaded(state.tenant) && tenantId) {
        tenantActions.get(tenantId);
    }
});
export default {
    auth: authActions,
    cases: Object.assign(Object.assign({}, caseActions), casesActions),
    tenantBilling: tenantBillingActions,
    transactionAccounts: transactionAccountActions,
    caseVouchers: caseVouchersActions,
    creditors: creditorsActions,
    customers: customersActions,
    hooks: hooksActions,
    keys: keysActions,
    economy: economyActions,
    home: homeActions,
    imports: importsActions,
    insights: insightsActions,
    workflows: workflowsActions,
    interactions: interactionsActions,
    me: meActions,
    lang: langActions,
    exclusiveContent: exclusiveContentActions,
    local: localActions,
    procedures: proceduresActions,
    redirect: redirectActions,
    owners: selectedOwnersActions,
    templates: templates,
    tenants: tenantActions,
    updates: updatesTypesActions,
    users: usersActions,
    newInteractions: newInteractions,
    loadCaseWorkerAppData,
    integrations: integrationActions,
    blameLogs: blameLogActions,
    voucherApplications: voucherApplicationActions,
    updateTypeGroups: updateTypeGroupsActions,
};
//# sourceMappingURL=actions.js.map